import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { formatDate } from 'date-fns'
import { UseFormSetError } from 'react-hook-form'
import { toast } from 'sonner'

export default function useUpdateMoneyPath({
  id,
  setError = null,
  clientServerFieldMapping = null,
}: {
  id: number | string
  setError: any
  clientServerFieldMapping: object
}) {
  const queryClient = useQueryClient()

  const action = async ({
    name,
    description,
    vaultId,
    percentage,
  }: {
    name: string
    description: string
    vaultId: number
    percentage: number
  }) => {
    const response = await httpClient.put(`team/money-paths/${id}`, {
      name,
      description,
      vault_id: vaultId,
      // start_date: formatDate(new Date(), 'yyyy-MM-dd'),
      percentage,
      // is_enabled: isEnabled,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Money Path updated.')
      queryClient.invalidateQueries({ queryKey: ['money-paths'] })
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
      queryClient.invalidateQueries({
        queryKey: ['transactions'],
      })
    },
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
